<div class="filter-group" data-group-visibility-id="showOtherHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showOtherHighlights" (click)="filter.groupVisibility.showOtherHighlights = !filter.groupVisibility.showOtherHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Other Items" [activeRules]="activeRules.otherItemFilters"></span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showOtherHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showOtherHighlights">
      <div class="filter filter-property full-span" [class.disabled]="!filter.showQuestItems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQuestItems" (click)="toggleHighlightQuestItems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quest Items" [additionalContent]="questItemsStylePreview" ruleId="quest-items">
            @if (poe1) {
              This also highlights <strong>Stones of Passage</strong> in Incursions and <strong>Watchstones</strong>.
            }
            <ng-template #questItemsStylePreview>
              <app-custom-rule-style-picker
                [filter]="filter"
                [active]="filter.showQuestItems"
                ruleId="quest-items"
                [defaultVisible]="true"
                [disabled]="!filter.showQuestItems"
                [exampleName]="poe2 ? 'Una\'s Lute' : 'Medicine Chest'"
                [title]="'Quest Items'"
                [isQuestItem]="true"></app-custom-rule-style-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTrialItems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTrialItems" (click)="toggleHighlightTrialItems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ poe2 ? isMobile() ? 'Trial Relics' : 'Trial of the Sekhemas Relics' : 'The Forbidden Sanctum Relics' }}" [additionalContent]="trialItemsStylePreview" ruleId="trial-relics">
            <ng-template #trialItemsStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.ItemsTrialItems"
                [active]="filter.showTrialItems"
                [exampleName]="trialRelicExampleName()"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete [style]="'width: ' + (isMobile() ? '' : '170px')"
            [options]="relicBaseTypeAutocompleteOptions"
            [disabled]="!filter.showTrialItems"
            [showOptions]="true"
            [selectedValues]="filter.showTrialItemTypes"
            (selectedValuesChange)="onTrialRelicTypesChange($event)"
          ></app-autocomplete>
          <span class="sep"></span>
          <div class="filter-title filter-label table-checkbox-group" [class.disabled]="trialHideOtherRelicsDisabled">
            <span class="input-group-btn">
              <button class="btn toggle-btn" [class.off]="!filter.hideOtherTrialItems" [disabled]="trialHideOtherRelicsDisabled" (click)="toggleHideOtherTrialItems()"></button>
            </span>
            <div class="table-checkbox-label">
              <span class="filter-title-text">{{ isMobile() ? 'Hide others' : 'Hide other relic types' }}</span>
            </div>
          </div>
        </span>
      </div>

      @if (poe2) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showTrialKeys">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showTrialKeys" (click)="toggleHighlightTrialKeys()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Trial {{ isMobile() ? '' : 'of the Sekhemas' }} Keys" [additionalContent]="trialKeysStylePreview">
              <ng-template #trialKeysStylePreview>
                @if (filter.showTrialKeys) {
                  <app-custom-rule-style-picker
                    [filter]="filter"
                    [active]="filter.showTrialKeys"
                    ruleId="trial-gold-key"
                    [defaultVisible]="true"
                    [exampleName]="'Gold Key'"
                    [title]="'Gold Key'"
                    [isCurrency]="true"></app-custom-rule-style-picker>

                  <app-custom-rule-style-picker
                    [filter]="filter"
                    [active]="filter.showTrialKeys"
                    ruleId="trial-silver-key"
                    [defaultVisible]="true"
                    [exampleName]="'Silver Key'"
                    [title]="'Silver Key'"
                    [isCurrency]="true"></app-custom-rule-style-picker>

                  <app-custom-rule-style-picker
                    [filter]="filter"
                    [active]="filter.showTrialKeys"
                    ruleId="trial-bronze-key"
                    [defaultVisible]="true"
                    [exampleName]="'Bronze Key'"
                    [title]="'Bronze Key'"
                    [isCurrency]="true"></app-custom-rule-style-picker>
                  }
              </ng-template>
            </span>
          </span>
        </div>
      }

      @if (poe1) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showHeistEnchantedBlueprints">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showHeistEnchantedBlueprints" (click)="toggleHighlightHeistEnchantedBlueprints()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Enchanted Blueprints' : 'Heist Enchanted Blueprints' }}" [additionalContent]="enchantedBlueprintsStylePreview" ruleId="heist-enchanted-blueprints">
              Enchanted Heist Blueprints and Contracts can be found in Mirages.
              <ng-template #enchantedBlueprintsStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.ItemsHeistEnchantedBlueprints"
                  [active]="filter.showHeistEnchantedBlueprints"
                  [exampleName]="'Enchanted Blueprint'"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.ItemsHeistEnchantedContracts"
              filterPropertyName="showHeistEnchantedContracts"
              labelText="Enchanted Contracts"
              exampleName="Contract">
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property full-span" [class.disabled]="!filter.showHeistBlueprints">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showHeistBlueprints" (click)="toggleHighlightHeistBlueprints()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'Blueprints' : 'Heist Blueprints' }}" [additionalContent]="blueprintsStylePreview" ruleId="heist-blueprints">
              Optionally specify the locations of the Heist Contracts and Blueprints to highlight. Each location requires different skills, and each skill unlocks different rewards.
              <br /><br />

              <span class="tooltip-row">
                <span>
                  <strong>Rewards Legend</strong><br />
                  @for (reward of heistRewardsData; track reward.name) {
                    <img class="effect-icon" [src]="reward.image" /> {{ reward.name }}<br />
                  }
                </span>

                <span>
                  <strong>Skills Legend</strong><br />
                  @for (skill of heistSkillsData; track skill.name) {
                    <img class="effect-icon" [src]="skill.image" /> {{ skill.name }}<br />
                  }
                </span>
              </span>

              <ng-template #blueprintsStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.ItemsHeistBlueprints"
                  [active]="filter.showHeistBlueprints"
                  [exampleName]="'Blueprint' + ((filter.showHeistLocations.length > 0 && filter.showHeistLocations[0] !== 'All') ? ': ' + filter.showHeistLocations[0] : '')"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="!filter.showHeistContracts" (click)="toggleHighlightHeistContracts()" [disabled]="!filter.showHeistBlueprints"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">{{ isMobile() ? 'Contr.' : 'Contracts' }}</span>

                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.ItemsHeistContracts"
                  [active]="filter.showHeistContracts"
                  [exampleName]="'Contract' + ((filter.showHeistLocations.length > 0 && filter.showHeistLocations[0] !== 'All') ? ': ' + filter.showHeistLocations[0] : '')"></app-equipment-tier-picker>
              </div>
            </div>
            <span class="sep"></span>
            <app-autocomplete [style]="'width: ' + (isMobile() ? '' : '150px')"
              [options]="heistLocations"
              [disabled]="!filter.showHeistBlueprints && !filter.showHeistContracts"
              [showOptions]="true"
              [selectedValues]="filter.showHeistLocations"
              (selectedValuesChange)="filter.showHeistLocations = $event; updateFilter();"
            ></app-autocomplete>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.ItemsRoguesMarkers"
            filterPropertyName="showRoguesMarkers"
            exampleName="Rogue's Marker">
            <img src="{{ imgPrefix }}/img/icons/heist.png" title="Rogue's Markers">
          </app-filter-checkbox-group>
        </div>
      }

      @if (poe2) {
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showRareWaystones" (click)="toggleHighlightRareWaystones()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Rare Waystones" [additionalContent]="rareWaystonesStylePreview" [class.disabled]="!filter.showRareWaystones" ruleId="waystones-rare">
              <ng-template #rareWaystonesStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.ItemsWaystonesRare"
                  [active]="filter.showRareWaystones"
                  [exampleName]="'Waystone (Tier 15)'"
                  [isWaystone]="true"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <!-- <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.ItemsWaystonesDelirium"
              filterPropertyName="showDeliriumWaystones"
              [labelText]="isMobile() ? 'Delirium' : 'Delirium Waystones'"
              exampleName="Waystone (Tier 15)"></app-filter-checkbox-group> -->
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.ItemsWaystonesOther"
              filterPropertyName="showOtherWaystones"
              [labelText]="isMobile() ? 'Other' : 'Other Waystones'"
              exampleName="Waystone (Tier 15)"
              [isWaystone]="true"></app-filter-checkbox-group>
          </span>
        </div>
      } @else if (poe1) {
        <div class="filter filter-property full-span">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.show6LinkedGear"
              (click)="toggleHighlight6LinkedItems()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="6-Link Items" [additionalContent]="SixLinkedItemsStylePreview" ruleId="gear-six-linked">
              <ng-template #SixLinkedItemsStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGear6LinkedItems"
                  [alignLeft]="true"
                  [active]="filter.show6LinkedGear"
                  [exampleName]="'Example Item'"
                  [sockets]="'LRRRRRR'"></app-equipment-tier-picker>
              </ng-template>
            </span>
          </span>
        </div>
      }

    </div>
    <div class="clear"></div>
  }
</div>
